module.exports = {"$schema":"http://iglucentral.com/schemas/com.snowplowanalytics.self-desc/schema/jsonschema/1-0-0#","self":{"vendor":"com.codecombat","name":"confirmed_restart","format":"jsonschema","version":"1-0-0"},"type":"object","properties":{"user":{"type":"string","pattern":"^[a-z0-9]{24}$","maxLength":24,"minLength":24},"label":{"type":"string"},"level":{"type":"string"}},"required":["user","label","level"],"additionalProperties":false}


//////////////////
// WEBPACK FOOTER
// ./app/schemas/events/confirmed_restart.json
// module id = 531
// module chunks = 100